//Constants Used throughout DOM
var originalViewport = $('meta[name="viewport"]').attr("content");

(function ($) {
    // Check if Anchor exists then slides
    if (window.location.hash) {
        var full_url = window.location.href;
        var parts = full_url.split("#");
        var trgt = parts[1];

        var target_offset = $("#" + trgt).offset();
        if (target_offset != null) {
            var target_top = target_offset.top - 125;
            $("html, body").animate({ scrollTop: target_top }, 1000, "easeInSine");
        }
    }

    $.smartbanner(
        {
            daysHidden: 4,
            daysReminder: 0,
            layer: false,
            title: "IHMVCU Mobile",
            author: "IH Mississippi Valley Credit Union",
            appendToSelector: ".ihSmartBanner",
            hideOnInstall: true,
        },
        function () {
            $("#ihContentHolder").css("margin-top", "130px");
        }
    );

    $('a[href*=".pdf"]').prop("target", "_blank");

    //Adds "is-filled" to login form labels if autofill info is present
    window.addEventListener("DOMContentLoaded", () => {
        setTimeout(() => {
            const loginInput = document.querySelector(
                'input[name="userid"], input[name="u"]'
            );

            if (loginInput?.value.trim()) {
                loginInput.closest('label')?.classList.add('is-filled');
            }
        }, 500);
    });

    //Adds Class of "ihLocal" or "ihExternal" to links
    $("a").each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            $(this).addClass("ihLocal");
        } else {
            if (
                this.hostname === "www.ihmvcu.org" ||
                this.hostname === "www.ihmvcuinvestmentservices.org" ||
                this.hostname === "businessloan.ihmvcu.org" ||
                this.hostname === "www.ihmvcuonline.org" ||
                this.hostname === "webloan.ihmvcu.org" ||
                this.hostname === "chat.ihmvcu.org" ||
                this.hostname === "ihmissvalleycredit.fluidreview.com" ||
                this.hostname === "secure.andera.com" ||
                this.hostname === "www.eservicepayments.com" ||
                this.hostname === "mortgageloan.ihmvcu.org" ||
                this.hostname === "stagingihmvcuorg-cm-bcdahgckggfaf2gw.centralus-01.azurewebsites.net" ||
                this.hostname === "stagingihmvcuorg-cd-a3ckhyhee7hafha6.centralus-01.azurewebsites.net" ||
                this.hostname === "apply.ihmvcu.org" ||
                this.hostname === "my.ihmvcu.org" ||
                this.hostname === "uat-my.ihmvcu.org"
            ) {
                $(this).addClass("ihLocal");
            } else {
                $(this).addClass("ihExternal");
            }
        }
    });

    //If "ihExternal" link open popup
    $("a.ihExternal").on("click", function (e) {
        if ($(this).hasClass("ihLocal")) {
        } else {
            e.preventDefault();
            externalLinkPopUp($(this));
        }
    });

    $(".ihSubscribeForm .form-result-popup, .ihEnewsPop").on(
        "click",
        function (e) {
            $("#ihOverlay").fadeIn();
            $("#mce-EMAIL").val($(".ihMarketingEmail").val());
            $(".ihEmailSignUp").show();
            $(".ihThirdPartyDisclaimer").hide();
        }
    );

    $(".ihGoBackLink").on("click", function (e) {
        history.back();
    });

    //Overlay Fades Out on Click
    $("#ihOverlay").on("click", function (e) {
        e.stopPropagation();
        if ($(e.target).attr("id") == "ihOverlay") {
            $("#ihOverlay").fadeOut().removeClass("ihThirdPartyLink");
        }
    });
    $(".ihOverlayCloseBtn").on("click", function (e) {
        $("#ihOverlay").fadeOut().removeClass("ihThirdPartyLink");
    });
    $(
        'a[href="/business/invest/investment-services"],a[href="/banking/invest/ihmvcu-investment-services"]'
    ).on("click", function (e) {
        e.preventDefault();
        window.open("https://www.IHMVCUInvestmentServices.org", "_blank");
    });
})(jQuery);

//Toggles Mobile CSS on/off

//Sets Cookie
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

//Gets Cookie
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function externalLinkPopUp(element) {
    $(".ihEmailSignUp").hide();

    var hrefLoc = $(element).attr("href");
    $(".ihThirPartyDisclaimerBtn").attr("href", hrefLoc);
    $(".ihThirPartyDisclaimerBtn strong").html(hrefLoc);
    $("#ihOverlay").addClass("ihThirdPartyLink").fadeIn();
    $(".ihEmailSignUp").hide();
    $(".ihThirdPartyDisclaimer").show();
}
